import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import RegisterBlock from "../modules/RegisterBlock";
import globals from '../globals';
import HelmetDefault from "../layout/HelmetDefault";
import IndigoSection from "../modules/IndigoSection";
import Heading from "../elements/Heading";
import ResponsiveTable from "../elements/ResponsiveTable";
import Button from "../elements/Button";

class WirelessBackup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            seoTitle: '',
            seoDescription: '',
            telstraContent: {
                description: [],
                table: {headings: [], rows: []},
                coverageUrl: ''
            },
            dataReceived: false
        };
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        fetch('/api/internet/wireless-backup')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        const Content = (item, isIndigoBg = false) => {
            return (
                <div className="row centered">
                    <div className="col-xs-12 col-md-8 col-md-offset-2">
                        <Heading title={item.title} subTitle={item.subTitle}>
                            {item.description.map((item, key) => {
                                return <p key={key}>{item}</p>;
                            })}
                        </Heading>
                        <ResponsiveTable data={item.table} className={`mt-5 ${isIndigoBg ? 'with-indigo-bg' : ''}`} />
                        <p className="mt-2" dangerouslySetInnerHTML={{__html: item.terms}} />
                    </div>
                    <div className="d-none d-md-block col-md-8 col-md-offset-2 mt-5">
                        <h2>{item.coverageTitle}</h2>
                        <p>
                            {item.coverageCopy}
                            <br />
                        </p>
                        <Button action={item.coverageUrl} image={item.type === 'optus' ? '/images/btn-coverage-map.svg' : '/images/btn-coverage-map-dark.svg'} />
                    </div>
                </div>
            );  
        };

        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}} className="wireless-backup">
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <section className="first-section mb-5">
                    {Content(this.state.telstraContent)}
                </section>
                <RegisterBlock />
            </div>
        );
    }

}

export default WirelessBackup;


// WEBPACK FOOTER //
// ./resources/assets/js/internet/WirelessBackup.js